export enum ServicePackEmailNotificationState {
	NoMailSent = 0,
	InitialReminderSent = 1,
	HasBeenBought = 2,
	EmailAboutToExpireSent = 3
}

export class ClientMailNotifications {
	id:number = 0;
	companyId:number = 0;
	servicePackEmail:ServicePackEmailNotificationState = ServicePackEmailNotificationState.NoMailSent;

	constructor(data?:any){
		if (!data) return;
		this.id = data.id;
		this.companyId = data.companyId;
		this.servicePackEmail = data.servicePackEmail;
	}
}